/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { Box } from "@mui/system";
import { AxiosError } from "axios";
import api from "../../services/api";
import { useEffect, useState, useCallback, useRef } from "react";
import ModalAlerta from "../../components/modal";
import { BiMoneyWithdraw } from "react-icons/bi";
import { FiTruck, FiUser } from "react-icons/fi";
import { useAppSelector } from "../../store/hooks";
import { Tooltip, Typography } from "@mui/material";
import { MdBalance, MdMoneyOff, MdReportGmailerrorred, MdSecurity } from 'react-icons/md';
import Dashboardv2 from "../../components/dashboard_v2";
import ChangelogModal from "../../components/ChangelogModal";
import { LocaSmartLayout } from "../../components/locasmart-layout";
import ModalAlertaTemporario from "../../components/modal-temporario";
import { obterIdTenent, obterNomeUsuario, tokenExpirado, usuarioTemPermissao } from "../../services/seguranca";
import { CARDS_DO_DASHBOARD } from "../../services/permissoes-token";
import { FaCar, FaCarSide, FaCashRegister, FaCheckCircle, FaCogs, FaFileInvoiceDollar, FaHandshake, FaHandshakeSlash, FaMoneyBill, FaMotorcycle, FaOilCan } from "react-icons/fa";
import { AcessoProps, ApiError, ContextoLancamento, Dashboard, StatusPagamento, TipoLancamento, TipoStatusLancamento } from "../../services/tipos";
import { PeriodicidadeDashboard, converterStatusPagamentoParaTexto, converterTipoLancamentoParaTexto, converterTipoStatusLancamentoParaTexto, converterTipoVeiculoParaTexto, formatarParaReais, tratarErroApi } from "../../services/utilitarios";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import ModalTreinamento from "../../components/modal-treinamento";
import PesquisaBanner from "../../components/pesquisa-banner";
import ModalTreinamentoPosVenda from '../../components/modal-treinamento-posvenda';
import ModalPrioridades from '../onboarding/ModalPrioridades';
import GoogleReviewModal from '../../components/google-review-modal';

function Home(props: AcessoProps) {
    const [acao] = useState(props.match.params.acao);
    const [messageAlertaTemp] = useState<string[]>([]);
    const [carregando, setCarregando] = useState(true);
    const [showAlerta, setShowAlerta] = useState(false);
    const [pagamentos, setPagamentos] = useState<any[]>([]);
    const [lancamentos, setLancamentos] = useState<any[]>([]);
    const [showAlertaTemp, setShowAlertaTemp] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageAlerta, setMessageAlerta] = useState<string[]>([]);
    const [showChangeLog, setShowChangeLog] = useState<boolean>(false);
    const [dashboard, setDashboard] = useState<Dashboard>({} as Dashboard);
    const [dataInicioPeriodo, setDataInicioPeriodo] = useState<Date>(new Date());
    const [dataFimPeriodo, setDataFimPeriodo] = useState<Date>(new Date());
    const history = useHistory();
    const dispatch = useDispatch();
    const isFirstRender = useRef(true);

    const [loadingPagamentos, setLoadingPagamentos] = useState(false);
    const [carregandoTotalizadores, setCarregandoTotalizadores] = useState(false);
    const [carregandoLancamentos, setCarregandoLancamentos] = useState(false);

    const [pagamentosPagination, setPagamentosPagination] = useState({
        page: 1,
        pageSize: 10,
        totalCount: 0
    });

    const tratarErro = useCallback((error: AxiosError<ApiError>) => {
        setMessageAlerta(tratarErroApi(error, 'Não foi possível consultar o Dashboard '));
        setShowAlerta(true);
        setCarregando(false);
        setLoadingPagamentos(false);
    }, []);

    const buscarPagamentosPorDatas = useCallback(async (dataIni: Date, dataFim: Date, page: number = 1, pageSize: number = 10) => {
        if (!token || tokenExpirado(token)) {
            setMessageAlerta(['Token expirado ou inválido']);
            setShowAlerta(true);
            setCarregando(false);
            return;
        }
        
        if (!usuarioTemPermissao(token, 'pagamento_visualizar') || !usuarioTemPermissao(token, 'dashboard_lista_pagamentos')) {
            setPagamentos([]);
            return;
        }

        setLoadingPagamentos(true);

        try {
            const dataInicialFormatada = dataIni.toISOString().split('T')[0];
            const dataFinalFormatada = dataFim.toISOString().split('T')[0];
            
            const response = await api.get(`/PorEmpresaPorIntervalo/${obterIdTenent(token)}/${dataInicialFormatada}/${dataFinalFormatada}`, {
                params: { page, pageSize }
            });
            
            let dadosPagamentos = [];
            let total = 0;

            if (response.data.items) {
                dadosPagamentos = response.data.items;
                total = response.data.totalCount;
            } else {
                dadosPagamentos = Array.isArray(response.data) ? response.data : [response.data];
                total = dadosPagamentos.length;
            }

            setPagamentosPagination(prev => ({
                ...prev,
                totalCount: total
            }));

            const pagamentosFormatados = dadosPagamentos.map((p: any) => ({
                locatario: `${p.locacao.locatario.nome}`,
                placa: p.locacao.veiculo.placa,
                marca: p.locacao.veiculo.marca,
                modelo: p.locacao.veiculo.modelo,
                tipoVeiculo: p.locacao.veiculo.tipoVeiculo,
                dataPrevista: new Date(p.dataPrevista).toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }),
                valor: p.valor.toFixed(2),
                status: converterStatusPagamentoParaTexto(p.status),
            }));
            
            setPagamentos(pagamentosFormatados);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setLoadingPagamentos(false);
        }
    }, [token, tratarErro]);

    const buscarLancamentosPorDatas = useCallback(async (dataIni: Date, dataFim: Date) => {
        if (!usuarioTemPermissao(token, 'lancamento_visualizar') || !usuarioTemPermissao(token, 'dashboard_lista_lancamentos')) {
            setLancamentos([]);
            return;
        }

        setCarregandoLancamentos(true);
        const contexto: ContextoLancamento = {
            idEmpresa: obterIdTenent(token),
            dataInicial: dataIni || undefined,
            dataFinal: dataFim || undefined,
            status: TipoStatusLancamento.Todos,
            tipo: TipoLancamento.Todos,
        };

        try {
            const response = await api.get('/ObterTodosPorContexto', {
                params: contexto,
            });
            
            const lancamentosOrdenados = response.data.sort((a: any, b: any) => {
                const dataA = new Date(a.dataRealizado).getTime();
                const dataB = new Date(b.dataRealizado).getTime();
                return dataB - dataA;
            });

            const lancamentosFormatados = lancamentosOrdenados.map((l: any) => ({
                descricao: `${l.descricao}`,
                valor: `${l.valor.toFixed(2)}`,
                dataPrevista: new Date(l.dataRealizado).toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }),
                tipo: converterTipoLancamentoParaTexto(l.tipo),
                tipoLancamento: l.tipo,
                status: converterTipoStatusLancamentoParaTexto(l.status),
                statusLancamento: l.status,
                lancamentoCategorias: l.lancamentoCategorias
            }));

            setLancamentos(lancamentosFormatados);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregandoLancamentos(false);
        }
    }, [token, tratarErro]);

    const buscarTotalizadores = useCallback(async (dataInicial: Date, dataFinal: Date) => {
        if (!usuarioTemPermissao(token, 'dashboard_visualizar')) {
            setDashboard({} as Dashboard);
            return;
        }

        setCarregandoTotalizadores(true);
        try {
            if (!token || tokenExpirado(token)) {
                return;
            }

            const response = await api.get(`/DashboardPorEmpresa/${obterIdTenent(token)}`, {
                params: {
                    dataInicial,
                    dataFinal,
                },
            });
            setDashboard(response.data);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregandoTotalizadores(false);
        }
    }, [token, tratarErro]);

    // Listas e calendário buscam em Pagamento e Lançamento: além do card, precisam da permissão do módulo.
    const modulosDoCard: Record<string, string> = {
        dashboard_lista_pagamentos: 'pagamento_visualizar',
        dashboard_lista_lancamentos: 'lancamento_visualizar',
        dashboard_calendario: 'pagamento_visualizar',
    };
    const podeVerNoDashboard = (chave: string) =>
        usuarioTemPermissao(token, chave) && (!modulosDoCard[chave] || usuarioTemPermissao(token, modulosDoCard[chave]));

    const handlePeriodoChange = useCallback(async (periodo: PeriodicidadeDashboard, dataInicio?: Date, dataFim?: Date) => {
        let datInicio;
        let datFim;

        const dataDeHoje = new Date();
        dataDeHoje.setHours(0, 0, 0, 0);

        switch (periodo) {
            case PeriodicidadeDashboard.mesAtual:
                datInicio = new Date(dataDeHoje.getFullYear(), dataDeHoje.getMonth(), 1);
                datFim = new Date(dataDeHoje.getFullYear(), dataDeHoje.getMonth() + 1, 0);
                break;
            case PeriodicidadeDashboard.semanaAtual:
                let diaDaSemana = dataDeHoje.getDay();
                datInicio = new Date(dataDeHoje);
                datInicio.setDate(dataDeHoje.getDate() - diaDaSemana);
                datFim = new Date(datInicio);
                datFim.setDate(datInicio.getDate() + 6);
                break;
            case PeriodicidadeDashboard.ultimosQuinzeDias:
                datInicio = new Date(dataDeHoje);
                datInicio.setDate(dataDeHoje.getDate() - 15);
                datFim = dataDeHoje;
                break;
            case PeriodicidadeDashboard.ultimosTrintaDias:
                datInicio = new Date(dataDeHoje);
                datInicio.setDate(dataDeHoje.getDate() - 30);
                datFim = dataDeHoje;
                break;
            case PeriodicidadeDashboard.ultimoAno:
                datInicio = new Date(dataDeHoje.getFullYear(), 0, 1);
                datFim = new Date(dataDeHoje.getFullYear(), 11, 31);
                break;
            case PeriodicidadeDashboard.personalizado:
                if (dataInicio && dataFim) {
                    datInicio = dataInicio;
                    datFim = dataFim;
                } else {
                    datInicio = new Date(dataDeHoje);
                    datInicio.setDate(dataDeHoje.getDate() - dataDeHoje.getDay());
                    datFim = new Date(datInicio);
                    datFim.setDate(datInicio.getDate() + 6);
                }
                break;
            default:
                datInicio = dataDeHoje;
                datFim = dataDeHoje;
                break;
        }

        try {
            setDataInicioPeriodo(datInicio);
            setDataFimPeriodo(datFim);
            
            setPagamentosPagination(prev => ({ ...prev, page: 1 }));

            buscarPagamentosPorDatas(datInicio, datFim, 1, pagamentosPagination.pageSize);
            buscarLancamentosPorDatas(datInicio, datFim);
            buscarTotalizadores(datInicio, datFim);
            
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        }
    }, [buscarPagamentosPorDatas, buscarLancamentosPorDatas, buscarTotalizadores, tratarErro, pagamentosPagination.pageSize]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (dataInicioPeriodo && dataFimPeriodo && !loadingPagamentos) {
            buscarPagamentosPorDatas(dataInicioPeriodo, dataFimPeriodo, pagamentosPagination.page, pagamentosPagination.pageSize);
        }
    }, [pagamentosPagination.page]); 

    useEffect(() => {
        if (!token || tokenExpirado(token)) {
            history.push('/login');
            return;
        }
    
        const fetchDashboard = async () => {
            try {
                await handlePeriodoChange(PeriodicidadeDashboard.mesAtual);
                const searchParams = new URLSearchParams(window.location.search);
                if (searchParams.get('changelog') === 'true') {
                    setTimeout(() => setShowChangeLog(true), 1000);
                }
            } catch (error) {
                setCarregando(false);
                if ((error as AxiosError).response?.status === 401) {
                    dispatch({ type: 'LOG_OUT' });
                    history.push('/login');
                }
            } finally {
                setCarregando(false);
            }
        }
    
        fetchDashboard();
    }, [token, handlePeriodoChange, history, dispatch]);

    const handleHide = () => setShowAlerta(false);

    const detalhamentoQuantidade = (lista?: { tipoVeiculo: number; quantidade: number }[]) =>
        (lista || [])
            .slice()
            .sort((a, b) => a.tipoVeiculo - b.tipoVeiculo)
            .map(t => ({ label: converterTipoVeiculoParaTexto(t.tipoVeiculo, true), valor: t.quantidade }));

    const detalhamentoValor = (lista?: { tipoVeiculo: number; valor: number }[]) =>
        (lista || [])
            .slice()
            .sort((a, b) => a.tipoVeiculo - b.tipoVeiculo)
            .map(t => ({ label: converterTipoVeiculoParaTexto(t.tipoVeiculo, true), valor: formatarParaReais(t.valor) }));

    const formatarData = (data: string) => {
        const [dia, mes, ano] = data.split('/');
        return `${ano}-${mes}-${dia}`;
    };

    const formatarDataReal = (data: Date) => {
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const dia = String(data.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
    };

    const periodoQuery = () =>
        `dataInicio=${formatarDataReal(dataInicioPeriodo)}&dataFim=${formatarDataReal(dataFimPeriodo)}`;

    const origensRecebimento = (
        valorPagamento: number,
        valorLancamento: number,
        statusPagamento: StatusPagamento,
        statusLancamento: TipoStatusLancamento,
    ) => ([
        {
            label: "Pagamentos",
            valor: valorPagamento,
            iconColor: "#1f4680",
            icon: FaMoneyBill,
            link: `/pagamento?status=${statusPagamento}&${periodoQuery()}`,
        },
        {
            label: "Lançamentos",
            valor: valorLancamento,
            iconColor: "#7c3aed",
            icon: FaFileInvoiceDollar,
            link: `/lancamento?tipo=${TipoLancamento.Entrada}&status=${statusLancamento}&${periodoQuery()}`,
        },
    ]);

    const origensMultas = (vencidas: number, aVencer: number, pagas: number) => ([
        {
            label: "Vencidas",
            valor: vencidas,
            iconColor: '#D32F2F',
            link: `/multas?status=2&${periodoQuery()}`,
        },
        {
            label: "A vencer",
            valor: aVencer,
            iconColor: '#D32F2F',
            link: `/multas?status=3&${periodoQuery()}`,
        },
        {
            label: "Pagas",
            valor: pagas,
            iconColor: '#D32F2F',
            link: `/multas?status=1&${periodoQuery()}`,
        },
    ]);

    const handleVisualizarPagamentos = (dataInicio: string, dataFim: string, nome: string) => {
        const dataInicioFormatada = formatarData(dataInicio);
        const dataFimFormatada = formatarData(dataFim);

        const urlMontada = `/pagamento?search=${nome}&dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}&status=-1`;
        window.location.href = urlMontada;
    }

    const handleVisualizarLancamentos = (dataInicio: string, dataFim: string, descricao: string) => {
        const dataInicioFormatada = formatarData(dataInicio);
        const dataFimFormatada = formatarData(dataFim);

        const urlMontada = `/lancamento?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}&search=${descricao}`;
        window.location.href = urlMontada;
    };

    function renderData(data: any) {
        let date: Date;
        if (typeof data === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
            const [dia, mes, ano] = data.split("/");
            date = new Date(+ano, +mes - 1, +dia);
        } else {
            date = new Date(data);
        }

        if (isNaN(date.getTime())) return '';

        const diasDaSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
        const diaSemana = diasDaSemana[date.getDay()];

        const dataFormatada = date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

        const resetHora = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

        const hoje = resetHora(new Date());
        const comparada = resetHora(date);

        let textoExtra = `(${diaSemana})`;

        const diffMs = comparada.getTime() - hoje.getTime();
        const diffDias = diffMs / (1000 * 60 * 60 * 24);

        if (diffDias === -1) textoExtra = "(Ontem)";
        else if (diffDias === 0) textoExtra = "(Hoje)";
        else if (diffDias === 1) textoExtra = "(Amanhã)";
        else textoExtra = `(${diaSemana})`;

        return (
            <Box display="flex" flexDirection="column" lineHeight={1.2} alignItems={"start"}>
                <span>{dataFormatada}</span>
                <span style={{ fontSize: '13px', color: '#888' }}>{textoExtra}</span>
            </Box>
        );
    }

    return (
        <LocaSmartLayout>
            {acao === 'acessobloqueado'}
            <ModalAlerta show={showAlerta} message={messageAlerta} onHide={handleHide} />
                        <ModalAlertaTemporario
                            message={messageAlertaTemp}
                            show={showAlertaTemp}
                            onHide={() => { setShowAlertaTemp(false) }}
                            tempoEmSegundos={2}
                        />
            
                        {usuarioTemPermissao(token, 'dashboard_visualizar') && CARDS_DO_DASHBOARD.some(c => usuarioTemPermissao(token, c.chave)) ? (
                            <Dashboardv2
                                onPeriodoChange={handlePeriodoChange}
                                user={obterNomeUsuario(token).split(' ')[0]}
                                graficos={[
                                    {
                                        dados: dashboard.faturamentoPorVeiculo,
                                        titulo: "Faturamento/Veículo (Até agora)",
                                        subtitulo: "Comparativo de faturamento entre os veículos da sua locadora",
                                        name: "Faturamento",
                                        permissao: "dashboard_grafico_faturamento"
                                    },
                                    {
                                        dados: dashboard.custoPorVeiculo,
                                        titulo: "Custo/Veículo (Até agora)",
                                        subtitulo: "Comparativo de custo/despesas entre os veículos da sua locadora",
                                        name: "Custo",
                                        permissao: "dashboard_grafico_custo"
                                    },
                                    {
                                        dados: dashboard.lucroPorVeiculo,
                                        titulo: "Lucro/Veículo (Até agora)",
                                        subtitulo: "Comparativo de lucro entre os veículos da sua locadora",
                                        name: "Lucro",
                                        permissao: "dashboard_grafico_lucro"
                                    }
                                ]}
                                cards={[
                                    { icon: FaHandshake, title: 'Locações Ativas', permissao: 'dashboard_locacoes_ativas', subtitle: String(dashboard.totalizadoresLocacoesAtivas | 0), iconColor: '#2ECBA6', carregando: carregandoTotalizadores, link: "/locacao?search=Ativa", info: "Somatório de Locações com Status 'Ativa'", },
                                    { icon: FaHandshakeSlash, title: 'Locações Encerradas', permissao: 'dashboard_locacoes_encerradas', subtitle: String(dashboard.totalizadoresLocacoesEncerradas | 0), iconColor: '#B0BEC5', carregando: carregandoTotalizadores, link: "/locacao?search=Encerrada", info: "Somatório de Locações com Status 'Encerrada' ou 'Inativa'", },
                                    {
                                        icon: FaCar, title: 'Veículos Disponíveis', permissao: 'dashboard_veiculos_disponiveis', subtitle: String(dashboard.totalizadoresVeiculosDisponiveis | 0), iconColor: '#28A745', carregando: carregandoTotalizadores, link: "/veiculo?search=parado",
                                        info: "Somatório de Veículos que não estão em Locações 'Ativas'",
                                        detalhamento: detalhamentoQuantidade(dashboard.veiculosDisponiveisPorTipo),
                                    },
                                    {
                                        icon: FaMotorcycle, title: 'Veículo em Locação', permissao: 'dashboard_veiculos_em_locacao', subtitle: String(dashboard.totalizadoresVeiculosEmLocacao | 0), iconColor: '#2196F3', carregando: carregandoTotalizadores, link: "/veiculo?search=em locação",
                                        info: "Somatório de Veículos que estão em Locações 'Ativas'",
                                        detalhamento: detalhamentoQuantidade(dashboard.veiculosEmLocacaoPorTipo),
                                    },
                                    {
                                        icon: FaCogs, title: 'Manutenções Realizadas', permissao: 'dashboard_manutencoes', subtitle: formatarParaReais(dashboard.gastoEmServicos), iconColor: '#00d9ff', carregando: carregandoTotalizadores, link: "/manutencoes",
                                        info: "Total gasto com manutenções realizadas no período selecionado",
                                    },
                                    {
                                        icon: MdBalance, title: 'Investido em Veículos', permissao: 'dashboard_investido_veiculos', subtitle: formatarParaReais(dashboard.investidoEmVeiculo), iconColor: '#FFD700', carregando: carregandoTotalizadores, link: "/veiculo",
                                        info: "Valor total investido na sua frota de veículos, incluindo carros, motos e caminhões",
                                        detalhamento: detalhamentoValor(dashboard.investidoEmVeiculoPorTipo),
                                    },
                                    {
                                        icon: MdReportGmailerrorred, title: 'Multas', permissao: 'dashboard_multas', subtitle: formatarParaReais(dashboard.totalizadoresSomaMultas), iconColor: '#D32F2F', carregando: carregandoTotalizadores,
                                        info: "Valor total em infrações de trânsito",
                                        origens: origensMultas(dashboard.totalizadoresSomaMultasVencidas, dashboard.totalizadoresSomaMultasAVencer, dashboard.totalizadoresSomaMultasPagas),
                                    },
                                    {
                                        icon: FaMoneyBill, title: 'Recebimentos A Vencer', permissao: 'dashboard_recebimentos_a_vencer',
                                        subtitle: formatarParaReais((dashboard.totalizadoresSomaPagamentosPendentes + dashboard.totalizadoresSomaLancamentoEntradaPendente)), iconColor: '#FFA500', carregando: carregandoTotalizadores,
                                        info: "Total de lançamentos financeiros de entrada e pagamentos, ambos com status 'Pendente', previstos para o período selecionado",
                                        origens: origensRecebimento(
                                            dashboard.totalizadoresSomaPagamentosPendentes,
                                            dashboard.totalizadoresSomaLancamentoEntradaPendente,
                                            StatusPagamento.Pendente,
                                            TipoStatusLancamento.Pendente,
                                        ),
                                    },
                                    {
                                        icon: FaMoneyBill, title: 'Recebimentos Concluídos', permissao: 'dashboard_recebimentos_concluidos', subtitle: formatarParaReais((dashboard.totalizadoresSomaPagamentosPagos + dashboard.totalizadoresSomaLancamentoEntradaResolvido))
                                        , iconColor: '#28A745', carregando: carregandoTotalizadores, info: "Total de lançamentos financeiros de entrada e pagamentos, ambos com status 'Resolvido' e 'Pago', previstos para o período selecionado",
                                        origens: origensRecebimento(
                                            dashboard.totalizadoresSomaPagamentosPagos,
                                            dashboard.totalizadoresSomaLancamentoEntradaResolvido,
                                            StatusPagamento.Pago,
                                            TipoStatusLancamento.Resolvido,
                                        ),
                                    },
                                    {
                                        icon: MdMoneyOff, title: 'Recebimentos em Atraso', permissao: 'dashboard_recebimentos_em_atraso', subtitle: formatarParaReais(dashboard.totalizadoresSomaPagamentosAtraso + dashboard.totalizadoresSomaLancamentoEntradaVencidas), iconColor: '#FF5722', carregando: carregandoTotalizadores,
                                        info: "Total de pagamentos e lançamentos de entrada com status 'Em atraso' / 'Vencido', previstos para o período selecionado",
                                        origens: origensRecebimento(
                                            dashboard.totalizadoresSomaPagamentosAtraso,
                                            dashboard.totalizadoresSomaLancamentoEntradaVencidas,
                                            StatusPagamento.EmAtraso,
                                            TipoStatusLancamento.Pendente,
                                        ),
                                    },
                                    {
                                        icon: BiMoneyWithdraw, title: 'Despesas Resolvidas', permissao: 'dashboard_despesas_resolvidas', subtitle: formatarParaReais(dashboard.totalizadoresSomaLancamentoSaidaResolvido), iconColor: '#1565C0', carregando: carregandoTotalizadores,
                                        link: `/lancamento?dataInicio=${formatarDataReal(dataInicioPeriodo)}&dataFim=${formatarDataReal(dataFimPeriodo)}&status=${TipoStatusLancamento.Resolvido}&tipo=${TipoLancamento.Saida}`,
                                        info: "Total de lançamentos de saída com status 'Resolvido', previstos para o período selecionado"
                                    },
                                    {
                                        icon: BiMoneyWithdraw, title: 'Despesas A vencer', permissao: 'dashboard_despesas_a_vencer', subtitle: formatarParaReais(dashboard.totalizadoresSomaLancamentoSaidaPendente), iconColor: '#FFA500', carregando: carregandoTotalizadores,
                                        link: `/lancamento?dataInicio=${formatarDataReal(dataInicioPeriodo)}&dataFim=${formatarDataReal(new Date())}&status=${TipoStatusLancamento.Pendente}&tipo=${TipoLancamento.Saida}`,
                                        info: "Total de lançamentos de saída com status 'A vencer', previstos para o período selecionado"
                                    },
                                    {
                                        icon: BiMoneyWithdraw, title: 'Despesas em Atraso', permissao: 'dashboard_despesas_em_atraso', subtitle: formatarParaReais(dashboard.totalizadoresSomaLancamentoSaidaVencidas), iconColor: '#D32F2F', carregando: carregandoTotalizadores,
                                        link: `/lancamento?dataInicio=${formatarDataReal(new Date())}&dataFim=${formatarDataReal(dataFimPeriodo)}&status=${TipoStatusLancamento.Pendente}&tipo=${TipoLancamento.Saida}`,
                                        info: "Total de lançamentos de saída com status 'Vencida', previstos para o período selecionado"
                                    },
                                    {
                                        icon: FaCashRegister, title: 'Dif Entradas - Saídas', permissao: 'dashboard_saldo', subtitle: formatarParaReais(dashboard.saldoEntradasSaidas), iconColor: '#4CAF50 ', carregando: carregandoTotalizadores,
                                        info: "Valor referente a diferença entre Entradas *Resolvidas* e Saídas *Resolvidas*"
                                    },
                                    {
                                        icon: FaCheckCircle, title: 'Vistorias Realizadas', permissao: 'dashboard_vistorias', subtitle: String(dashboard.totalizadoresVistorias || 0), iconColor: '#4CAF50 ', carregando: carregandoTotalizadores,
                                        info: "Total de vistorias registradas"
                                    },
                                    {
                                        icon: FaOilCan, title: 'Trocas de Óleo', permissao: 'dashboard_trocas_de_oleo', subtitle: String(dashboard.totalizadoresTrocasDeOleo || 0), iconColor: '#4CAF50 ', carregando: carregandoTotalizadores,
                                        info: "Total de trocas de óleo registradas"
                                    }
                                ]}
                                grids={[
                                    {
                                        fields: [
                                            {
                                                label: 'Locação', property: 'locacao', render(value, row) {
                                                    const getVehicleIcon = () => {
                                                        switch (Number(row.tipoVeiculo)) {
                                                            case 1: return <FaCarSide size={16} />;
                                                            case 2: return <FaMotorcycle size={16} />;
                                                            case 3: return <FiTruck size={16} />;
                                                            default: return <FaCarSide size={16} />;
                                                        }
                                                    };
            
                                                    const veiculoLabel = `${row.placa}: ${row.marca} ${row.modelo}`
            
                                                    return (
                                                        <Box display="flex" flexDirection="column" py={0.5}>
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <FiUser size={16} />
                                                                <Typography variant="body2">{row.locatario}</Typography>
                                                            </Box>
                                                            <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                                                                {getVehicleIcon()}
                                                                <Typography variant="body2">{veiculoLabel}</Typography>
                                                            </Box>
                                                        </Box>
                                                    );
                                                }, searchValue: (value, row) => {
                                                    return `${row.locatario} ${row.placa} ${row.marca} ${row.modelo}`;
                                                }
                                            },
                                            {
                                                label: 'Data Prevista', property: 'dataPrevista', render(value, row) {
                                                    return (<>
                                                        {renderData(value)}
                                                    </>)
                                                },
                                            },
                                            {
                                                label: 'Valor', property: 'valor', render(value, row) {
                                                    return (<>
                                                        R$ {value}
                                                    </>)
                                                },
                                            },
                                            {
                                                label: 'Status', property: 'status', render(value, row) {
                                                    const status = value;
                                                    const statusText = status;
            
                                                    let backgroundColor;
                                                    if (status === 'Pago') {
                                                        backgroundColor = '#4CAF50';
                                                    } else if (status === converterStatusPagamentoParaTexto(StatusPagamento.Pendente)) {
                                                        backgroundColor = '#FFC107';
                                                    } else if (status === 'Em Atraso') {
                                                        backgroundColor = '#f44336';
                                                    } else {
                                                        backgroundColor = '#f44336';
                                                    }
            
                                                    const labelStyle: React.CSSProperties = {
                                                        backgroundColor,
                                                        color: 'white',
                                                        padding: '5px 10px',
                                                        borderRadius: '5px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'center' as 'center',
                                                    };
            
                                                    return (
                                                        <span style={labelStyle}>
                                                            {statusText}
                                                        </span>
                                                    );
                                                },
                                            },
                                        ],
                                        dataSource: pagamentos,
                                        title: 'Pagamentos',
                                        permissao: 'dashboard_lista_pagamentos',
                                        viewMoreLink: '/pagamento',
                                        carregando: loadingPagamentos,
                                        pagination: {
                                            page: pagamentosPagination.page,
                                            pageSize: pagamentosPagination.pageSize,
                                            totalCount: pagamentosPagination.totalCount,
                                            onPageChange: (newPage) => {
                                                setPagamentosPagination(prev => ({ ...prev, page: newPage }));
                                            }
                                        },
                                        onRowClick(rowData) {
                                            const dataInicio = rowData.dataPrevista;
                                            const dataFim = rowData.dataPrevista;
                                            const locatario = rowData.locatario;
                                            handleVisualizarPagamentos(dataInicio, dataFim, locatario);
                                        },
                                    },
                                    {
                                        fields: [
                                            {
                                                label: 'Valor',
                                                property: 'valor',
                                                render(value, row) {
                                                    const tipo = row.tipoLancamento;
                                                    const valor = Number(value);
                                                    const isEntrada = tipo === TipoLancamento.Entrada;
                                                    const valorFormatado = formatarParaReais(isEntrada ? valor : valor * -1);
            
                                                    const containerStyle: React.CSSProperties = {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-start',
                                                    };
            
                                                    const valueStyle: React.CSSProperties = {
                                                        color: isEntrada ? '#10B981' : '#EF4444',
                                                        fontWeight: 500,
                                                        fontSize: '0.875rem',
                                                        position: 'relative',
                                                        paddingLeft: '20px'
                                                    };
            
                                                    const iconStyle: React.CSSProperties = {
                                                        position: 'absolute',
                                                        left: 0,
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        fontSize: '1rem'
                                                    };
            
                                                    return (
                                                        <div style={containerStyle}>
                                                            <span style={valueStyle}>
                                                                {isEntrada ? (
                                                                    <span style={{ ...iconStyle, color: '#10B981' }}>↑</span>
                                                                ) : (
                                                                    <span style={{ ...iconStyle, color: '#EF4444' }}>↓</span>
                                                                )}
                                                                {valorFormatado}
                                                            </span>
                                                        </div>
                                                    );
                                                }
                                            },
                                            {
                                                label: 'Data Prevista',
                                                property: 'dataPrevista',
                                                render(value, row) {
                                                    const status = row.statusLancamento;
                                                    const isResolvido = status == TipoStatusLancamento.Resolvido;
                                                    const isPendente = status == TipoStatusLancamento.Pendente;
                                                    const [dia, mes, ano] = value.split('/');
                                                    const dataValue = new Date(+ano, +mes - 1, +dia);
            
                                                    const hoje = new Date();
                                                    hoje.setHours(0, 0, 0, 0);
                                                    dataValue.setHours(0, 0, 0, 0);
            
                                                    const isVencido = dataValue < hoje && isPendente;
            
                                                    const formattedDate = value;
            
                                                    return (
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            justifyContent: 'flex-start'
                                                        }}>
                                                            <span style={{
                                                                fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                                                                fontSize: '0.875rem'
                                                            }}>
                                                                {formattedDate}
                                                            </span>
            
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                {isResolvido && (
                                                                    <Tooltip title="Resolvido">
                                                                        <div style={{
                                                                            backgroundColor: '#ECFDF5',
                                                                            borderRadius: '50%',
                                                                            width: '24px',
                                                                            height: '24px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="16"
                                                                                viewBox="0 0 24 24"
                                                                                fill="#10B981"
                                                                            >
                                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                                                            </svg>
                                                                        </div>
                                                                    </Tooltip>
                                                                )}
                                                                {isPendente && !isVencido && (
                                                                    <Tooltip title="A Vencer">
                                                                        <div style={{
                                                                            backgroundColor: '#FFFBEB',
                                                                            borderRadius: '50%',
                                                                            width: '24px',
                                                                            height: '24px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="16"
                                                                                viewBox="0 0 24 24"
                                                                                fill="#F59E0B"
                                                                            >
                                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                                                                            </svg>
                                                                        </div>
                                                                    </Tooltip>
                                                                )}
                                                                {isVencido && (
                                                                    <Tooltip title="Vencido">
                                                                        <div style={{
                                                                            backgroundColor: '#FEF2F2',
                                                                            borderRadius: '50%',
                                                                            width: '24px',
                                                                            height: '24px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="16"
                                                                                viewBox="0 0 24 24"
                                                                                fill="#EF4444"
                                                                            >
                                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                                                                            </svg>
                                                                        </div>
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            },
                                            {
                                                label: 'Categoria',
                                                property: 'categoria',
                                                render(value, row) {
                                                    const lancamentoCategorias = row.lancamentoCategorias || [];
            
                                                    return (
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '4px',
                                                            width: '100%'
                                                        }}>
                                                            {lancamentoCategorias.map((item: any) => {
                                                                const categoria = item.categoria;
                                                                if (!categoria) return null;
            
                                                                return (
                                                                    <Tooltip key={item.id} title={categoria.descricao}>
                                                                        <div style={{
                                                                            backgroundColor: categoria.cor,
                                                                            color: 'white',
                                                                            padding: '4px 8px',
                                                                            borderRadius: '12px',
                                                                            fontWeight: 500,
                                                                            textAlign: 'center',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                            width: 'fit-content',
                                                                            maxWidth: '100%',
                                                                            fontSize: '0.75rem'
                                                                        }}>
                                                                            {categoria.nome}
                                                                        </div>
                                                                    </Tooltip>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                },
                                                searchValue: (value, row) => {
                                                    return row.lancamentoCategorias
                                                        ?.map((item: any) => item.categoria?.nome || '')
                                                        .join(' ') || '';
                                                }
                                            },
                                            {
                                                label: 'Descrição',
                                                property: 'descricao',
                                                render(value, row) {
                                                    return (
                                                        <Typography variant="body2">
                                                            {value}
                                                        </Typography>
                                                    );
                                                }
                                            }
                                        ],
            
                                        dataSource: lancamentos,
                                        title: 'Lançamentos',
                                        permissao: 'dashboard_lista_lancamentos',
                                        viewMoreLink: 'lancamento',
                                        carregando: carregandoLancamentos,
                                        onRowClick(rowData) {
                                            const dataInicio = rowData.dataPrevista;
                                            const dataFim = rowData.dataPrevista;
                                            const descricao = rowData.descricao;
                                            handleVisualizarLancamentos(dataInicio, dataFim, descricao);
                                        },
                                    }
                                ]}
                                mostrarCalendario={podeVerNoDashboard('dashboard_calendario')}
                                podeVer={podeVerNoDashboard}
                            />
                        ) : (
                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                height="100%"
                                minHeight="60vh"
                                textAlign="center"
                                p={4}
                            >
                                <MdSecurity size={80} color="#cbd5e1" />
                                <Typography variant="h5" sx={{ mt: 3, fontWeight: 600, color: '#1e293b' }}>
                                    Acesso Restrito
                                </Typography>
                                <Typography variant="body1" sx={{ mt: 1, color: '#64748b', maxWidth: '400px' }}>
                                    Você não possui permissão para visualizar os indicadores do Dashboard.
                                    Entre em contato com o administrador para solicitar acesso.
                                </Typography>
                            </Box>
                        )}            <ChangelogModal show={showChangeLog} onClose={() => { setShowChangeLog(false) }} />

            <ModalTreinamento />
            <PesquisaBanner />
            <ModalTreinamentoPosVenda />
            <ModalPrioridades />
            <GoogleReviewModal />
        </LocaSmartLayout>
    );
}

export default Home;